import React from 'react';
import CabPageShell from './CabPageShell';

const AdminCabsSettings = () => (
  <CabPageShell
    title="Settings"
    description="Configure cab module settings and defaults."
  />
);

export default AdminCabsSettings;
